import React, { useState } from 'react'
import axios from '../../../data/http/axios'
import AutoComplete from '~/Common-Objects/AutoComplete'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import i18n from '~/i18n'

function parser(data) {
    return data.Organisations.map((d) => ({ label: d.name, value: d.id }))
}

export default function ChangeOrganisation({ SubscriberId, onChange = () => {}, onCancel = () => {} }) {
    const [newName, setNewName] = useState('')

    const save = async (id) => {
        await axios.put('/subscriber/' + SubscriberId + '/organisation', {
            OrganisationId: id
        })
        onChange()
    }

    const create = async () => {
        const response = await axios.post('/organisation', {
            name: newName
        })
        await save(response.data.Organisation.id)
    }

    return (
        <div>
            <div className='mar-b25'>
                <div className='txtInput_label'>{i18n.t('subscribers:subscriber.changeOrg.org')}</div>
                <AutoComplete
                    url='/organisation?plain=true&limit=100&searchText={{name}}'
                    inputName='Organisation'
                    onKeyUp={setNewName}
                    parser={parser}
                    placeholder={i18n.t('subscribers:subscriber.changeOrg.placeholder')}
                    onChange={(o) => save(o.value)}
                />
            </div>
            <div className='quickFlex'>
                <Button
                    disabled={newName < 3}
                    text={i18n.t('subscribers:subscriber.changeOrg.create')}
                    className='button-primary mar-r10'
                    onClick={create}
                />
                <Button text={i18n.t('subscribers:subscriber.changeOrg.cancel')} onClick={onCancel} />
            </div>
        </div>
    )
}
